import * as React from 'react';
import { IAppPropsWithRoute } from '../../common/types';
import { withRouter } from 'react-router-dom';
import { useDispatch} from 'react-redux';
import { showNavbar } from '../../store/modules/appStateSlice';
import AddEditPcrWidget from './AddEditPcrWidget';
import { throttle } from 'lodash';

interface AddEditClusterPageProps extends IAppPropsWithRoute {

};

const AddEditPcrPage: React.FC<AddEditClusterPageProps> = (props) => {
    const dispatch = useDispatch();
    
    React.useEffect(() => {
        dispatch(showNavbar(false));
    }, [dispatch])
    const pcrId = props.match.params.pcrId;
    
    return (
        <>
            <AddEditPcrWidget id={pcrId} />
        </>
    );
}

export default withRouter(AddEditPcrPage);